import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, IconWrapper, Icon, InputBg } from './styles';
import { FinalFormInput } from '@utex/ui-kit';
import visa from './static/img/visa.svg';
import mastercard from './static/img/mastercard.svg';
import mir from './static/img/mir.svg';

interface Props {
  currency: string;
}

const cardNumberMask = '9999 9999 9999 9999 999'.split('').map((v) => (v !== '9' ? v : /\d/));

const cardHolderNamePipe = {
  mask: Array(256).fill(/./),
  pipe: (value: string) => ({ value: value.toUpperCase() }),
};

export const CardFields: React.FC<Props> = ({ currency }) => {
  const { t } = useTranslation('withdraw');

  return (
    <Container>
      <IconWrapper>
        <Icon src={visa} />
        <Icon src={mastercard} />
        {currency === 'RUB' && <Icon src={mir} />}
      </IconWrapper>
      <InputBg>
        <FinalFormInput
          name="cardNumber"
          id="cardNumber"
          type="text"
          mask={cardNumberMask}
          placeholder={t('Card number')}
          view="small"
          hintView="error"
          hintPosition="right"
          autoComplete="cc-number"
          inputMode="numeric"
        />
      </InputBg>
      <InputBg>
        <FinalFormInput
          name="cardHolderName"
          id="cardHolderName"
          type="text"
          placeholder={t('Name on card')}
          view="small"
          hintView="error"
          hintPosition="right"
          autoComplete="cc-name"
          {...cardHolderNamePipe}
        />
      </InputBg>
    </Container>
  );
};
